/**
 * Copyright (c) 2016 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

/**
 * @description React uses the key prop to understand the
 * component-to-DOM Element relation which is then used for
 * the reconciliation process. It is therefore very important
 * that the key always remains unique, otherwise there is a good
 * chance React will mix up the elements and mutate the incorrect one.
 * It is also important that these keys remain static throughout
 * all re-renders in order to maintain best performance.
 *
 * @returns {*}
 */
export function generateIteratorKey() {
  const k = Math.random().toString().slice(2);
  return { key: k };
}

export const setCookie = (name, value, validDays) => {
  const days = validDays ? validDays : 1;
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + '; path=/';
};

export const getCookie = (name) => {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.search(name);
  return match !== -1 ? true : false;
};

export const deleteCookie = (name) => {
  document.cookie = name + '=; Max-Age=0; path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
};
